import { css } from '@emotion/core';
import styled from '@emotion/styled';

const baseStyles = ({ width }) =>
  css`
    width: ${width || '100%'};
  `;

const sizeStyles = ({ theme, sizeTop, sizeBottom, sizeLeft, sizeRight, paddingBottom, paddingTop }) => {
  const { spacings } = theme;

  const sizeMap = {
    ...(sizeTop && { marginTop: spacings[sizeTop] }),
    ...(sizeBottom && { marginBottom: spacings[sizeBottom] }),
    ...(sizeLeft && { paddingLeft: spacings[sizeLeft] }),
    ...(sizeRight && { paddingRight: spacings[sizeRight] }),
    ...(paddingBottom && { paddingBottom: spacings[paddingBottom] }),
    ...(paddingTop && { paddingTop: spacings[paddingTop] }),
  };

  return css`
    ${sizeMap};
  `;
};

const marginBottomStyles = ({ theme, bottom }) =>
  bottom &&
  css`
    margin-bottom: ${theme.spacings.giga};
  `;

const marginTopStyles = ({ theme, top }) =>
  top &&
  css`
    margin-top: ${theme.spacings.giga};
  `;

const singleBottomStyles = ({ theme, bottom, single }) =>
  bottom &&
  single &&
  css`
    margin-bottom: ${theme.spacings.kilo};
  `;

const doubleBottomStyles = ({ theme, bottom, double }) =>
  bottom &&
  double &&
  css`
    margin-bottom: ${theme.spacings.peta};
  `;

const tripleBottomStyles = ({ theme, bottom, triple }) =>
  bottom &&
  triple &&
  css`
    margin-bottom: ${theme.spacings.zetta};
  `;

const sideStyles = ({ theme, sides }) =>
  sides &&
  css`
    padding-left: ${theme.spacings.mega};
    padding-right: ${theme.spacings.mega};
  `;

const doubleSideStyles = ({ theme, sides, double }) =>
  sides &&
  double &&
  css`
    padding-left: ${theme.spacings.tera};
    padding-right: ${theme.spacings.tera};
  `;

const tripleSideStyles = ({ theme, sides, triple }) =>
  sides &&
  triple &&
  css`
    padding-left: ${theme.spacings.peta};
    padding-right: ${theme.spacings.peta};
  `;

const Spacing = styled('div')(
  baseStyles,

  // deprecated props
  marginBottomStyles,
  marginTopStyles,
  singleBottomStyles,
  doubleBottomStyles,
  tripleBottomStyles,
  sideStyles,
  doubleSideStyles,
  tripleSideStyles,

  // new sizing prop
  sizeStyles,
);

export default Spacing;
